/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { proposalsGetApiV3ProposalsOverPast7d } from "../../funcs/proposalsGetApiV3ProposalsOverPast7d.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$proposalsGetApiV3ProposalsOverPast7d: ToolDefinition = {
  name: "proposals-get-api-v3-proposals-over-past-7d",
  description: ``,
  tool: async (client, ctx) => {
    const [result, apiCall] = await proposalsGetApiV3ProposalsOverPast7d(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
